//トップページ　キービジュアルスライダー
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade} from 'swiper/modules';

export function idxFunc() {
  let indexTop = $("#indexTop").length;
  let resizecheck = $('#responsibleCheck').width();

  if(indexTop){
    let resizecheck = $('#responsibleCheck').width();
    let resizecheck2 = 0;
    
    $(window).on('load resize', function () {
      resizecheck = $('#responsibleCheck').width();
    });

    //FVアニメーション
    const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms))
    wait(0)
    .then(() =>{
      $("#indexTop").addClass('isShow');
      $(".mainview").addClass('isShow');
      return wait(600)
    })
    .then(() =>{
      $(".firstMainviewImgAnime").addClass('isShow');
      return wait(700)
    })
    .then(() => {
      $('.firstMainviewTxtAnime').addClass('isShow');
      return wait(400)
    })

    function indexCommonAnimeFunc() {
      $('.commonTwoColumn').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 300) {
          wait(0)
          .then(() => {
            if (!$(this).find('.imgBox').hasClass('isShow')) {
              $(this).addClass('isShow');
              $(this).find('.imgBox').addClass('isShow');
              $(this).find('.commonAnimeTit').addClass('isShow');
            }
            return wait(800)
          })
          .then(() =>{
            if (!$(this).find('.commonAnimeTxt').hasClass('isShow')) {
              $(this).find('.commonAnimeTxt').addClass('isShow');
              $(this).find('.moreBtn').addClass('isShow');
            }
            return wait(800)
          })
        }
      });
      
      $('.commonThreeColumn').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 300) {
          wait(0)
          .then(() => {
            if (!$(this).find('.imgBox01').hasClass('isShow')) {
              $(this).addClass('isShow');
              $(this).find('.imgBox01').addClass('isShow');
              $(this).find('.imgBox02').addClass('isShow');
              $(this).find('.commonAnimeTit').addClass('isShow');
            }
            return wait(800)
          })
          .then(() => {
            if (!$(this).find('.commonAnimeTxt').hasClass('isShow')) {
              $(this).find('.commonAnimeTxt').addClass('isShow');
              $(this).find('.moreBtn').addClass('isShow');
            }
            return wait(800)
          })
        }
      });

    }indexCommonAnimeFunc();

    $(window).on('load scroll', function () {
      indexCommonAnimeFunc();
    });
  }
}